import React from "react";
import { Box, Container } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import BlessYSisoImg from "../../assets/blessysiso.png";
import "./TrustedLogo.scss";

const TrustedLogo = () => {
  return (
    <Box className="blessYSiso">
      <Container maxWidth={false} className="customContainer">
        <Box className="blessIsoImg">
          <LazyLoadImage
            effect="blur"
            wrapperProps={{ style: { transitionDelay: "1s" } }}
            src={BlessYSisoImg}
            style={{ aspectRatio: "243 / 155" }}
            alt="BlessY Siso"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default TrustedLogo;
